var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"fixed","bottom":"0","width":"calc(100vw)","z-index":"9999"},attrs:{"id":"kt_copyright_footer"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_vm._v(" Copyright © "+_vm._s(_vm.currentYear)+" Total Biometric Solutions LLC. All rights reserved. ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }